import { PricingPlan } from '../types/pricing';

export const pricingPlans: PricingPlan[] = [
  {
    id: 'free',
    slug: 'free',
    name: 'Free',
    tagline: 'Знакомство с Astranum',
    priceMonthly: 0,
    priceYearly: 0,
    accentColor: '#888',
    ctaText: 'Начать бесплатно',
    services: [
      { id: 'horoscope_basic', name: 'Базовый гороскоп', description: 'Общий прогноз по знаку на день', icon: '🌟', value: 1, canDisable: false, priceReduction: 0 },
      { id: 'life_path', name: 'Число Жизненного Пути', description: '1 нумерологический расчёт', icon: '🔢', value: 2, canDisable: false, priceReduction: 0 },
      { id: 'profile_limited', name: 'Ограниченный профиль', description: 'Дата рождения, знак зодиака', icon: '👤', value: 1, canDisable: false, priceReduction: 0 },
      { id: 'articles', name: '1 статья/неделю', description: 'Контент-маркетинг', icon: '📰', value: 1, canDisable: false, priceReduction: 0 },
    ],
  },
  {
    id: 'base',
    slug: 'base',
    name: 'Base',
    tagline: 'Персональный минимум',
    priceMonthly: 290,
    priceYearly: 2440,
    accentColor: '#4fd1c5',
    ctaText: 'Выбрать Base',
    services: [
      { id: 'horoscope_personal', name: 'Персональный гороскоп', description: 'По дате/времени/месту рождения', icon: '✨', value: 3, canDisable: false, priceReduction: 0 },
      { id: 'numerology_basic', name: 'Нумерология: базовый', description: 'Число Жизненного Пути + Число Судьбы', icon: '🔢', value: 2, canDisable: false, priceReduction: 0 },
      { id: 'forecast_weekly', name: 'Прогноз на неделю', description: 'Персональный, не общий', icon: '📅', value: 3, canDisable: false, priceReduction: 0 },
      { id: 'compatibility_basic', name: 'Совместимость (базовая)', description: 'По знакам зодиака', icon: '💕', value: 2, canDisable: false, priceReduction: 0 },
    ],
  },
  {
    id: 'premium',
    slug: 'premium',
    name: 'Premium',
    tagline: 'Полная персонализация',
    priceMonthly: 690,
    priceYearly: 4900,
    accentColor: '#d4af37',
    isPopular: true,
    ctaText: 'Выбрать Premium',
    services: [
      { id: 'natal_chart', name: 'Натальная карта', description: 'Полный расчёт (Swiss Ephemeris)', icon: '🌌', value: 5, canDisable: false, priceReduction: 0 },
      { id: 'transits', name: 'Транзиты планет', description: 'Текущие влияния на натальную карту', icon: '🪐', value: 5, canDisable: false, priceReduction: 0 },
      { id: 'forecast_monthly', name: 'Прогноз на месяц', description: 'Персональный, детальный', icon: '📆', value: 4, canDisable: true, priceReduction: 50 },
      { id: 'numerology_full', name: 'Нумерология: полный', description: '7 расчётов (Путь, Судьба, Душа, Личность, Год, Месяц, День)', icon: '🔮', value: 4, canDisable: true, priceReduction: 100 },
      { id: 'lucky_dates', name: 'Благоприятные даты', description: 'Персональный календарь', icon: '🍀', value: 4, canDisable: true, priceReduction: 50 },
      { id: 'synastry', name: 'Синастрия', description: 'Полный расчёт совместимости по 2 человека', icon: '💞', value: 5, canDisable: true, priceReduction: 100 },
      { id: 'pdf_export', name: 'Экспорт в PDF', description: 'Отчёты для печати', icon: '📄', value: 3, canDisable: true, priceReduction: 30 },
      { id: 'priority_support', name: 'Приоритетная поддержка', description: 'Ответ в течение 24ч', icon: '🎧', value: 2, canDisable: true, priceReduction: 20 },
    ],
  },
  {
    id: 'pro',
    slug: 'pro',
    name: 'Pro',
    tagline: 'Экспертный уровень',
    priceMonthly: 990,
    priceYearly: 8320,
    accentColor: '#f4d03f',
    ctaText: 'Выбрать Pro',
    services: [
      { id: 'transits_advanced', name: 'Расширенные транзиты', description: 'Прогрессии, дирекции, соляр', icon: '🔭', value: 5, canDisable: true, priceReduction: 150 },
      { id: 'child_profiles', name: 'Детский профиль', description: 'Расчёты для детей (до 2 профилей)', icon: '👶', value: 4, canDisable: true, priceReduction: 100 },
      { id: 'no_ads', name: 'Без рекламы', description: 'Полностью чистый интерфейс', icon: '🚫', value: 2, canDisable: true, priceReduction: 50 },
      { id: 'consult_discount', name: 'Скидка на консультации', description: '-20% на консультации эксперта', icon: '🎓', value: 4, canDisable: false, priceReduction: 0 },
      { id: 'priority_support_pro', name: 'Приоритетная поддержка', description: 'Ответ в течение 6ч', icon: '⚡', value: 3, canDisable: false, priceReduction: 0 },
    ],
  },
];

export const oneTimeServices = [
  { id: 'lucky_dates_once', name: 'Благоприятные даты', description: 'Персональный календарь на 30 дней', price: 290, icon: '🍀' },
  { id: 'synastry_once', name: 'Совместимость', description: 'Полный расчёт синастрии', price: 490, icon: '💞' },
  { id: 'natal_chart_once', name: 'Натальная карта', description: 'Полный PDF-отчёт', price: 990, icon: '🌌' },
  { id: 'forecast_year_once', name: 'Прогноз на год', description: 'Детальный персональный прогноз', price: 1490, icon: '📆' },
  { id: 'numerology_full_once', name: 'Нумерология: полный', description: '7 расчётов + PDF', price: 690, icon: '🔮' },
];
